import { GenericFilter } from '@energybox/react-ui-library/dist/components';
import { IncidentStatus } from '@energybox/react-ui-library/dist/types';
import { capitalizeFirstLetterOnly } from '@energybox/react-ui-library/dist/utils';
import React from 'react';
import useIncidentStatusFilter from '../../../hooks/useIncidentStatusFilter';

const IncidentStatusFilter: React.FC = () => {
  const { setFilter, selectedIncidentStatusFilters } =
    useIncidentStatusFilter();

  return (
    <GenericFilter
      title="Status"
      setFilter={setFilter}
      items={Object.values(IncidentStatus)}
      transformItemName={capitalizeFirstLetterOnly}
      selectedItems={selectedIncidentStatusFilters}
    />
  );
};

export default IncidentStatusFilter;
